<template>
    <div class="pb4">

        <!-- image label -->
        <div :class="{'justify-between' : hasCancel}" class="flex items-center pv3 pv4-ns">
            <div class="flex items-center">
                <img style="width: 20px;" :src="image"/>
                <h6 class="ml2">{{imageLabel}}</h6>
            </div>

            <img v-if="hasCancel" @click="showWarning = true" class="grow pointer" src="@/assets/img/icon_x.svg">

        </div>

        <!-- heading -->
        <h4 class="">{{heading}}</h4>

        <!-- exit warning in edit mode -->
        <OverlayWarning :showWarning="showWarning">
            <ExitEdit @cancel="showWarning = false"/>
        </OverlayWarning>
    </div>
</template>

<script>
import OverlayWarning from '@/components/global/OverlayWarning.vue';
import ExitEdit from '@/components/editListing/popups/ExitEdit.vue';

export default {
    data() {
        return {
            showWarning: false
        };
    },
    components: {
        OverlayWarning,
        ExitEdit
    },
    props: {
        image: {
            type: String,
            required: true
        },
        imageLabel: {
            type: String,
            required: true
        },
        heading: {
            type: String,
            required: true
        },
        hasCancel: {
            type: Boolean,
            default: false
        }
    }
};
</script>
